// A Monica's reply is shown whole (no "show full message" clamp); only the
// agentic step groups collapse, in their own <details>. This hook copies the
// message and keeps a disclosure open across LiveView patches.
export default {
  mounted() {
    this.disclosureOpen = false
    this.click = async event => {
      const copy = event.target.closest('[data-room-copy]')
      if (!copy) return
      try {
        const content = this.el.querySelector('[data-room-message-text]')
        await navigator.clipboard.writeText(content?.innerText || content?.textContent || '')
        this.el.querySelector('[data-copy-status]').textContent = copy.dataset.copied
        copy.dataset.copiedState = 'true'
        clearTimeout(this.timer)
        this.timer = setTimeout(() => { delete copy.dataset.copiedState }, 1800)
      } catch (_) { this.el.querySelector('[data-copy-status]').textContent = copy.title }
    }
    this.toggle = event => { if(event.target.matches('[data-room-disclosure]')) this.disclosureOpen = event.target.open }
    this.el.addEventListener('click', this.click)
    this.el.addEventListener('toggle', this.toggle, true)
    this.sync()
  },
  sync() {
    const disclosure = this.el.querySelector('[data-room-disclosure]')
    if(disclosure) disclosure.open = this.disclosureOpen
  },
  updated() { this.sync() },
  destroyed() { clearTimeout(this.timer); this.el.removeEventListener('click',this.click); this.el.removeEventListener('toggle',this.toggle,true) }
}
